/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_AnalyticsInputs */

const en_admin_dashboard_analytics = /** @type {(inputs: Admin_Dashboard_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

const de_admin_dashboard_analytics = /** @type {(inputs: Admin_Dashboard_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswertungen`)
};

const es_admin_dashboard_analytics = /** @type {(inputs: Admin_Dashboard_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analíticas`)
};

const fr_admin_dashboard_analytics = /** @type {(inputs: Admin_Dashboard_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses`)
};

const nl_admin_dashboard_analytics = /** @type {(inputs: Admin_Dashboard_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses`)
};

const it_admin_dashboard_analytics = /** @type {(inputs: Admin_Dashboard_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi`)
};

const pt_br2_admin_dashboard_analytics = /** @type {(inputs: Admin_Dashboard_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise`)
};

const pl_admin_dashboard_analytics = /** @type {(inputs: Admin_Dashboard_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analityka`)
};

const hu_admin_dashboard_analytics = /** @type {(inputs: Admin_Dashboard_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemzések`)
};

const ro_admin_dashboard_analytics = /** @type {(inputs: Admin_Dashboard_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Admin_Dashboard_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_analytics = /** @type {((inputs?: Admin_Dashboard_AnalyticsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_AnalyticsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_analytics(inputs)
	if (locale === "de") return de_admin_dashboard_analytics(inputs)
	if (locale === "es") return es_admin_dashboard_analytics(inputs)
	if (locale === "fr") return fr_admin_dashboard_analytics(inputs)
	if (locale === "nl") return nl_admin_dashboard_analytics(inputs)
	if (locale === "it") return it_admin_dashboard_analytics(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_analytics(inputs)
	if (locale === "pl") return pl_admin_dashboard_analytics(inputs)
	if (locale === "hu") return hu_admin_dashboard_analytics(inputs)
	return ro_admin_dashboard_analytics(inputs)
});
export { admin_dashboard_analytics as "admin.dashboard.analytics" }